export default "__VITE_ASSET__CZ0h_szW__"